import Timer2 from 'components/Timer2';
import Layout from 'containers/Layout';
import React, { useState, useEffect } from 'react';
import SocialProof from 'components/SocialProof';
import Helmet from 'react-helmet';
import styled from 'styled-components';
import { width, sizes, helpers, colors, media } from 'styles/variables';
import Meta from 'utils/Meta';
import RichText from 'utils/RichText';
import { log, fblog, eclog, slog, splog } from 'utils/log';
import { navigate } from 'gatsby';
import { loadStripe } from '@stripe/stripe-js';
import GO from 'utils/GO';
import radio_0 from '../../static/radio_0.svg';
import radio_1 from '../../static/radio_1.svg';
import { PayPalButton } from 'react-paypal-button-v2';
import animateScrollTo from 'animated-scroll-to';
import VisibilitySensor from 'react-visibility-sensor';
import Button from 'components/Button';
import 'url-search-params-polyfill';
import firebase from 'gatsby-plugin-firebase';
import checkbox_0 from '../../static/checkbox_0.svg';
import checkbox_1 from '../../static/checkbox_1.svg';
import Script from 'react-load-script';
import axios from 'axios';
import cookie from 'react-cookies';

const Summary = styled.div`
	margin: 30px 0 0;
	width: 100%;
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: ${sizes[0]};
	padding: ${sizes[2]};
	.headline {
		font-size: 1.25rem;
		font-weight: bold;
		text-align: left;
		display: block;
	}
	.order,
	.total {
		display: grid;
		grid-template-columns: 1fr auto;
		grid-gap: ${sizes[1]};
		align-items: end;
		line-height: 1.25rem;
		.key {
			text-transform: capitalize;
			text-align: left;
			// font-weight: bold;
			strong {
				display: block;
				font-weight: 600;
				font-size: 0.9rem;
			}
		}
		.value {
			text-align: right;
			// font-weight: regular;
		}
	}
	.order {
		margin: ${sizes[2]} 0;
		padding: ${sizes[2]} 0;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
		font-size: 0.9rem;
	}
	.total {
		font-weight: bold;
		font-size: 1.1rem;
		margin-bottom: ${sizes[2]};
		padding-bottom: ${sizes[2]};
		border-bottom: 1px solid rgba(0, 0, 0, 0.1);
	}
`;
const PageWrapper = styled.div`
	.paddle-checkout {
		min-height: 200px;
		margin: 0 -0.65rem;
		position: relative;
		overflow: hidden;
		&.--loading:before {
			content: '';
			display: block;
			position: absolute;
			width: 200%;
			height: 200%;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
			z-index: 99;
			pointer-events: none;
			background: white;
			z-index: 999;
		}
		.loader {
			display: none;
		}
		&.--loading .loader {
			display: inline-block;
			position: absolute;
			top: 50%;
			left: 50%;
			width: 34px;
			height: 34px;
			margin-top: -17px;
			margin-left: -17px;
			border: 4px solid #f3f3f3;
			border-radius: 50%;
			border-top: 4px solid #ccc;
			animation: rotate 1s ease-in-out infinite forwards;
			z-index: 9999;
		}
		@keyframes rotate {
			from {
				transform: rotate(45deg);
			}
			to {
				transform: rotate(405deg);
			}
		}
	}
	.checkOutButton {
		width: 100%;
		background: ${colors.teal.base};
		margin: 5px 0;
		padding: 16px;
		color: #fff;
		font-size: 14px;
		font-weight: 500;
		border-radius: 4px;
		cursor: pointer;
		&:hover {
			filter: brightness(0.9);
		}
	}
	.checkOutBottom {
		img {
			width: 100%;
			max-width: 400px;
			margin: 0 0 15px;
		}
	}
	margin: 0 auto;
	width: 100%;
	max-width: ${width.small}px;
	text-align: center;
	overflow: hidden;
	h1 {
		font-size: 3rem;
	}
	${media.notsmall} {
		padding: ${sizes[4]} ${sizes[2]};
		img {
			width: 90%;
		}
	}
	${media.small} {
		h1 {
			padding: ${sizes[2]};
			font-size: 2rem;
		}
		padding: ${sizes[3]} 0 0;
		img {
			width: 110%;
			margin-left: -5%;
		}
	}
`;
const PaymentBlock = styled.div`
	position: relative;
	.PaymentButton {
		width: 100%;
		border-radius: ${sizes[0]};
		text-align: center;
		display: block;
		font-size: 1rem;
		padding: ${sizes[2]};
		color: ${colors.background[0]};
		background: ${colors.teal.base};
		cursor: pointer;
	}
	img {
		width: 100%;
		margin: 0;
		margin-top: ${sizes[1]};
	}
	.legalBlocker {
		display: block;
		position: absolute;
		top: -10px;
		right: -10px;
		bottom: -10px;
		left: -10px;
		z-index: 9999;
	}
	#chargedesk-wrapper {
		&.--loading {
			background: red;
			min-height: 80px;
			background: center no-repeat url(https://cdn.chargedesk.com/ajax-loader-large3.gif);
			background-size: 60px;
		}
		iframe {
			width: 250px;
		}
	}
	.legalOverlay {
		position: absolute;
		width: 100%;
		height: 100%;
		top: 0;
		left: 0;
		z-index: 999;
		&.--inactive {
			display: none;
		}
	}
`;
const Bot = styled.div`
	.paymentMethodButton {
		div {
			font-size: 0.9rem;
			margin-bottom: ${sizes[0]};
			border-radius: ${sizes[0]};
			color: ${colors.background[0]};
		}
	}
	label {
		display: grid;
		grid-template-columns: auto 1fr;
		grid-gap: ${sizes[1]};
		> div:first-of-type:before {
			content: '';
			display: block;
			width: 20px;
			height: 20px;
			background: center no-repeat;
			background-size: contain;
		}
		> div:first-of-type:before {
			background-image: url(${checkbox_0});
		}
		&.--active > div:first-of-type:before {
			background-image: url(${checkbox_1});
		}
		&.--alert {
			* {
				color: red;
				font-weight: bold;
			}
		}
	}
	input {
		display: none;
	}
	width: 100%;
	margin: ${sizes[3]} auto ${sizes[2]};
	text-align: left;
	* {
		color: ${colors.foreground[2]};
		font-size: 0.8rem;
		line-height: 1.25rem;
	}
	a {
		text-decoration: underline;
		&:hover {
			text-decoration: none;
		}
	}
`;

const Order2 = styled.div`
	display: grid;
	grid-auto-flow: row;
	grid-gap: ${sizes[2]};
	position: relative;
	max-width: 500px;
	margin: 0 auto;
	${media.notsmall} {
		padding: ${sizes[3]};
		border-radius: ${sizes[1]};
		margin-top: -${sizes[2]};
	}
	${media.small} {
		padding: ${sizes[2]};
		margin-top: -${sizes[1]};
	}
`;
const Plans2 = styled.div`
	display: grid;
	grid-auto-flow: columns;
	grid-auto-columns: auto;
	grid-gap: ${sizes[2]};
	${media.small} {
		grid-gap: ${sizes[1]};
	}
	label {
		position: relative;
		${helpers.shadow};
		padding: ${sizes[2]};
		border-radius: ${sizes[1]};
		background: ${colors.background[0]};
		border: 3px solid ${colors.background[0]};
		cursor: pointer;
		text-align: left;
		input[type='radio'] {
			display: none;
		}
		> div {
			display: grid;
			grid-template-columns: 30px 1fr;
		}
		.status:first-of-type:before {
			content: '';
			display: block;
			width: 20px;
			height: 20px;
			background: center no-repeat;
			background-size: contain;
			background-image: url(${radio_0});
		}
		&.--active .status:first-of-type:before {
			background-image: url(${radio_1});
		}
		&:hover {
			border-color: ${colors.teal.tint2};
		}
		h2 {
			font-size: 0.7rem;
			text-transform: uppercase;
			display: block;
		}
		h3 {
			font-size: 1.5rem;
			line-height: 2rem;
			display: block;
			span {
				background: none;
				color: ${colors.foreground[0]};
				font-size: 1rem;
				font-weight: normal;
				text-transform: lowercase;
			}
		}
		small {
			font-size: 0.7rem;
			display: block;
			margin-top: -5px;
			span {
				color: ${colors.foreground[2]};
				&:first-of-type {
					color: ${colors.brand.base};
					text-decoration: line-through;
				}
			}
		}
		.discount {
			position: absolute;
			top: ${sizes[2]};
			right: ${sizes[2]};
			background: ${colors.background[2]};
			border-radius: ${sizes[0]};
			padding: ${sizes[1]};
			text-align: center;
			font-size: 0.7rem;
			font-weight: 600;
			text-transform: uppercase;
			color: ${colors.foreground[2]};
		}
		&.--active {
			border-color: ${colors.teal.base};
			background: ${colors.teal.tint2};
			&:before {
				color: ${colors.background[0]};
			}
			.discount {
				background: ${colors.teal.base};
				color: ${colors.background[0]};
			}
		}
	}
`;
const Method = styled.div`
	display: grid;
	grid-auto-flow: columns;
	grid-auto-columns: auto;
	grid-gap: ${sizes[1]};
	${media.small} {
		grid-gap: ${sizes[1]};
	}
	label {
		position: relative;
		${helpers.shadow};
		padding: ${sizes[2]};
		border-radius: ${sizes[1]};
		background: ${colors.background[0]};
		border: 3px solid ${colors.background[0]};
		cursor: pointer;
		text-align: left;
		input[type='radio'] {
			display: none;
		}
		> div {
			display: grid;
			grid-template-columns: 30px 1fr;
		}
		.status:first-of-type:before {
			content: '';
			display: block;
			width: 20px;
			height: 20px;
			background: center no-repeat;
			background-size: contain;
			background-image: url(${radio_0});
		}
		&.--active .status:first-of-type:before {
			background-image: url(${radio_1});
		}
		&:hover {
			border-color: ${colors.teal.tint2};
		}
		h3 {
			font-size: 1.1rem;
			line-height: 100%;
			display: inline-block;
			margin: 0;
			font-weight: bold;
		}
		img {
			height: 22px;
			width: auto;
			display: block;
			margin-top: 10px;
		}
		&.--active {
			border-color: ${colors.teal.base};
			background: ${colors.teal.tint2};
			&:before {
				color: ${colors.background[0]};
			}
			.discount {
				background: ${colors.teal.base};
				color: ${colors.background[0]};
			}
		}
	}
`;
const Reviews = styled.div`
	padding: ${sizes[3]} 0;
	background: rgba(0, 0, 0, 0.025);
	> div {
		display: block;
	}
	h2 {
		font-size: 1.5rem;
		margin-bottom: ${sizes[3]};
		display: block;
		width: 100%;
		text-align: center;
	}
	a {
		${media.large} {
			grid-column: span 2;
		}
		> * {
			max-width: 380px;
			margin: 0 auto;
		}
	}
`;
const ReviewItem = styled.div`
	position: relative;
	display: grid;
	grid-template-rows: 1fr auto;
	grid-gap: ${sizes[3]};
`;
const ReviewBody = styled.div`
	${media.notlarge} {
		margin-top: 40px;
	}
`;
const ReviewFooter = styled.div`
	display: grid;
	grid-template-columns: auto 1fr auto;
	align-items: center;
	.avatar {
		width: 48px;
		margin-right: ${sizes[1]};
		border-radius: 99px;
	}
	strong,
	small {
		display: block;
	}
	.rating {
		height: 24px;
		${media.notlarge} {
			position: absolute;
			top: ${sizes[3]};
			left: ${sizes[3]};
		}
	}
`;

const Block = styled.div`
	padding: ${sizes[4]} ${sizes[2]};
	width: 100%;
	max-width: ${width.max}px;
	margin: 0 auto;
	display: grid;
	${media.notsmall} {
		grid-template-columns: 1fr 2fr;
	}
	${media.small} {
		grid-template-columns: 100%;
		padding-bottom: ${sizes[2]};
	}
	grid-gap: ${sizes[3]};
	h1 {
		font-size: 2.25rem;
	}
	p {
		font-size: 0.9rem;
	}
	a {
		display: block;
	}
	.cta {
		margin-top: ${sizes[2]};
	}
	&.plain,
	&.testimonials {
		grid-template-columns: 1fr;
		grid-auto-flow: row;
		text-align: center;
		.offer,
		.cta {
			display: none;
		}
	}
	&.plain {
		${media.notsmall} {
			padding: ${sizes[5]};
			h1 {
				font-size: 3rem;
			}
			a > div {
				max-width: 300px;
				margin: 0 auto;
			}
		}
		${media.small} {
			padding: ${sizes[4]} ${sizes[2]};
		}
		.cta {
			display: block;
		}
	}
`;
const Benefits2 = styled.div`
	background: rgba(0, 0, 0, 0.025);
	> div {
		padding: ${sizes[3]} ${sizes[2]};
		display: block;
		> div {
			display: grid;
			${media.large} {
				grid-template-columns: repeat(4, 1fr);
			}
			${media.notlarge} {
				grid-template-columns: repeat(2, 1fr);
			}
			grid-gap: ${sizes[1]};
			text-align: left;
			> div {
				display: grid;
				grid-template-columns: auto 1fr;
				align-items: center;
			}
			img {
				display: inline-block;
				${media.large} {
					width: 32px;
				}
				${media.notlarge} {
					width: 28px;
				}
			}
			p {
				display: inline-block;
				width: 100%;
				padding: 0 0 0 ${sizes[1]};
				white-space: nowrap;
				line-height: 100%;
				${media.large} {
					font-size: 1rem;
				}
				${media.notlarge} {
					font-size: 0.75rem;
				}
			}
		}
	}
	h2 {
		font-size: 1.5rem;
		margin-bottom: ${sizes[3]};
		display: block;
		width: 100%;
		text-align: center;
	}
	a {
		${media.large} {
			grid-column: span 4;
		}
		${media.notlarge} {
			grid-column: span 2;
		}
		> * {
			max-width: 380px;
			margin: 0 auto;
		}
	}
`;

export default props => {
	const lang = props.pageContext.lang || '';
	const [config] = useState(require(`data/${lang}_config`));
	const [meta] = useState(require(`data/_meta`));
	const [values, setValues] = useState(null);
	const [order, setOrder] = useState(require(`data/${lang}_order`));
	const [legal, setLegal] = useState(false);
	const [legalAlert, setLegalAlert] = useState(false);
	const [locale, setLocale] = useState(null);
	const [activeMethod, setActiveMethod] = useState(null);
	const [translations] = useState(require(`data/${lang}_translations`));

	const handleLegal = e => {
		const value = e.target.checked;
		if (value) {
			document.querySelector('.legal').className = 'legal --active';
			document.querySelector('.legalOverlay').className = 'legalOverlay --inactive';
		} else {
			document.querySelector('.legal').className = 'legal --inactive';
			document.querySelector('.legalOverlay').className = 'legalOverlay';
		}
	};
	const handleLegalOverlay = e => {
		document.querySelector('.legal').className = 'legal --alert';
	};

	const handlePaymentClick = () => {
		if (values) {
			axios
				.post('/.netlify/functions/email_update', {
					data: { email: values.json.email },
					params: { paid: 'false', initiate_checkout: 'chargedesk' },
				})
				.then(e => true);
		}
		fblog('track', 'AddToCart', { value: Number(getPlan().price_usd), currency: 'USD' });
		splog('ADD_CART', {
			currency: 'USD',
			price: Number(getPlan().price_usd),
			transaction_id: cookie.load('uid'),
		});
		eclog(getPlan(), 'add');
		log('Order', 'Store', 'InitiateCheckout');
		log('Order', 'Store', 'InitiateCheckout--chargedesk');
		eclog(getPlan(), 'checkout');
		slog(`Initiate Checkout (${getPlan().price_usd}, Chargedesk)`, values ? values.json.email : '');
		window.__insp && window.__insp.push(['tagSession', `addToCart`]);
		setTimeout(renderChargedesk, 100);
	};

	const renderChargedesk = () => {
		window.CDInterval = setInterval(() => {
			if (typeof window.ChargeDesk !== 'undefined') {
				clearInterval(window.CDInterval);

				if (document.querySelector('#chargedesk-wrapper')) {
					document.querySelector('#chargedesk-wrapper').classList.add('--loading');
					window.CDLInterval = setInterval(() => {
						if (document.querySelector('#chargedesk-wrapper').clientHeight > 100) {
							clearInterval(window.CDLInterval);
							document.querySelector('#chargedesk-wrapper').classList.remove('--loading');
						}
					}, 50);
				}

				window.ChargeDesk.embed({
					id: 'chargedesk-wrapper',
					company: 'reshape-me',
					product:
						process.env.NODE_ENV === 'production' &&
						!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
							? getPlan().cd_id
							: getPlan().cd_test_id,
					embed: 'pay',
					onSuccess: function(response) {
						console.log('---', response);
						window.location.replace(
							`${window.location.origin}${
								lang.length === 0 ? `` : `/${lang}`
							}/create-profile?id=${id}&cd=${response.customer_id}&cdg=${response.gateway_id}`,
						);
					},
					options: {
						showExtraInformation: false,
						hideProduct: true,
						email: values ? values.json.email : '',
					},
				});
			}
		}, 200);
	};

	const setActiveOrder = n => {
		console.log(n);
	};

	const id = typeof document !== 'undefined' ? new URLSearchParams(document.location.search).get('id') : '';
	useEffect(() => {
		if (!id) {
			id = localStorage.getItem('id');
			slog(`cp err6, id=${id}`, '');
			navigate(`/choose-plan?id=${id}`);
		}
		if (id) {
			axios.get('https://geoip.boredpanda.com/').then(response => {
				let geoip = response.data;
				setLocale(response.data);
			});
			try {
				firebase
					.auth()
					.signInWithEmailAndPassword(atob(id), '_reshape_no_password')
					.then(user => {
						window._uid = user.user.uid;
						firebase
							.firestore()
							.collection('users')
							.doc(window._uid)
							.get()
							.then(docRef => {
								let doc = docRef.data();
								if (typeof doc !== 'undefined') {
									setValues(doc);
									if (typeof doc.order === 'undefined') {
										let newOrder = JSON.parse(JSON.stringify(order));
										let newPlan;
										newOrder.plans = newOrder.plans.map((item, index) => {
											if (
												(index === 0 && window._exps.Lifetime === 1) ||
												(index === 1 && window._exps.Lifetime === 0)
											) {
												item.value = true;
												newPlan = item;
											} else {
												item.value = false;
											}
											return item;
										});
										setOrder(newOrder);
										firebase
											.firestore()
											.collection('users')
											.doc(window._uid)
											.update({
												order: newPlan,
											});
									} else {
										setPlan(doc.order);
									}
									let cdcxt =
										typeof document !== 'undefined'
											? new URLSearchParams(document.location.search).get('CDCxt')
											: false;
									if (cdcxt) {
										renderChargedesk();
									}
									let url = new URLSearchParams(document.location.search);
									if (url.has('cancel')) {
										window.history.replaceState(
											'',
											document.title,
											window.location.href.replace('cancel&', ''),
										);
										slog(`Cancel Checkout`, doc.json.email);
									}
								} else {
									slog(`cp err1, ${JSON.stringify(user)}`, '');
									navigate('/');
								}
							})
							.catch(err => {
								slog(`cp err2, ${JSON.stringify(err)}`, '');
								navigate('/');
							});
					})
					.catch(err => {
						slog(`cp err3, ${JSON.stringify(err)}`, '');
						navigate('/');
					});
			} catch (err) {
				slog(`cp err4, ${JSON.stringify(err)}`, '');
				navigate('/');
			}
		} else {
			slog(`cp err5, ${JSON.stringify(document.location)}`, '');
			navigate('/');
		}
	}, []);

	const handleCallToAction = e => {
		animateScrollTo(document.querySelector('#summary'));
	};

	const handleOptionChange = e => {
		const cdw = document.querySelector('#chargedesk-wrapper');
		if (cdw) {
			cdw.innerHTML = '';
		}
		animateScrollTo(document.querySelector('#paymentMethod'));
		fblog('track', 'CustomizeProduct');
		let newOrder = JSON.parse(JSON.stringify(order));
		let newPlan = {};
		newOrder.plans = newOrder.plans.map((item, index) => {
			if (item.name === e.target.value) {
				item.value = true;
				newPlan = item;
			} else {
				item.value = false;
			}
			return item;
		});
		setOrder(newOrder);
		firebase
			.firestore()
			.collection('users')
			.doc(window._uid)
			.update({
				order: newPlan,
			})
			.then(function() {
				console.log('Document updated successfully');
			})
			.catch(function(error) {
				console.error('Error updating document: ', error);
			});
	};

	const getPlan = () => {
		let plan;
		plan = order.plans.filter((item, index) => {
			return item.value;
		});
		if (plan.length) {
			return plan[0];
		} else {
			return order.plans[0];
		}
	};

	const setPlan = plan => {
		let newOrder = JSON.parse(JSON.stringify(order));
		let newPlan = {};
		if (plan) {
			newOrder.plans = newOrder.plans.map((item, index) => {
				if (item.name === plan.name) {
					item.value = true;
					newPlan = item;
				} else {
					item.value = false;
				}
				return item;
			});
		}
		setOrder(newOrder);
		firebase
			.firestore()
			.collection('users')
			.doc(window._uid)
			.update({
				order: newPlan,
			})
			.then(function() {
				console.log('Document updated successfully');
			})
			.catch(function(error) {
				console.error('Error updating document: ', error);
			});
	};

	const handleFinalization = async e => {
		e.preventDefault();
		axios
			.post('/.netlify/functions/email_update', {
				data: { email: values.json.email },
				params: { paid: 'false', initiate_checkout: 'stripe' },
			})
			.then(e => true);
		fblog('track', 'AddToCart', { value: Number(getPlan().price_usd), currency: 'USD' });
		splog('ADD_CART', { currency: 'USD', price: Number(getPlan().price_usd), transaction_id: cookie.load('uid') });
		eclog(getPlan(), 'add');
		log('Order', 'Store', 'InitiateCheckout');
		log('Order', 'Store', 'InitiateCheckout--stripe');
		slog(`Initiate Checkout (${getPlan().price_usd}, Stripe)`, values.json.email);
		eclog(getPlan(), 'checkout');
		window.__insp && window.__insp.push(['tagSession', `addToCart`]);
		const stripe = await loadStripe(
			process.env.NODE_ENV === 'production' &&
				!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
				? order.stripe_live_key
				: order.stripe_test_key,
		);
		log('Order', 'Checkout', 'stripe_redirect');
		stripe
			.redirectToCheckout({
				lineItems: [
					{
						price:
							process.env.NODE_ENV === 'production' &&
							!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
								? getPlan().stripe_live
								: getPlan().stripe_test,
						quantity: 1,
					},
				],
				mode: getPlan().name === 'lifetime' ? 'payment' : 'subscription',
				successUrl: `${window.location.origin}${
					lang.length === 0 ? `` : `/${lang}`
				}/create-profile?id=${id}&sid={CHECKOUT_SESSION_ID}`,
				cancelUrl: `${window.location.origin}${
					lang.length === 0 ? `` : `/${lang}`
				}/choose-plan?cancel&id=${id}`,
				customerEmail: values.json.email,
			})
			.then(result => {
				alert(result.error.message);
				navigate('/choose-plan/');
			});
	};

	order.plans.map((item, index) => {
		if (item.value === true) {
			log('Order', 'Plan', item.name);
			fblog('trackCustom', 'plan_' + item.name);
			eclog(item, 'click');
		}
	});

	const renderSummary = () => {
		return (
			<>
				<br />
				<br />
				<h2 id="paymentMethod">{translations.payment_method}</h2>
				<Method>
					{[
						{ name: 'card', title: translations.payment_card },
						{ name: 'paypal', title: 'PayPal' },
					].map((item, index) => (
						<label className={item.name === activeMethod ? '--active' : '--inactive'} key={index}>
							<input
								type="radio"
								name="plan"
								value={item.name}
								selected={item.name === activeMethod}
								onChange={() => {
									handlePaymentMethodChange(item.name);
									return true;
								}}
							/>
							<div>
								<div className="status" />
								<div>
									<h3>{item.title}</h3>
									<img src={`/method_${item.name}.svg`} />
								</div>
							</div>
						</label>
					))}
				</Method>
				<br />
				<br />
				<h2>{translations.order_summary}</h2>
				<style>{`
					.order {
						border-top:0 !important;
						padding-top:0 !important;
						margin-top:0 !important;
					}
					#summary {
						margin-top:-20px;
					}
				`}</style>
				<div id="summary">
					<Summary>
						<div className="order">
							<div className="key">
								<strong>Reshape Weight Loss Plan</strong>
								{getPlan().title}
							</div>
							<div className="value">${getPlan().full_price_usd}</div>
							{Number(getPlan().discount_usd) > 0 && (
								<>
									<div className="key">
										{translations.discount} <span>({getPlan().discount})</span>
									</div>
									<div className="value">
										<span>-${getPlan().discount_usd}</span>
									</div>
								</>
							)}
						</div>
						<div className="total">
							<div className="key">{translations.total}</div>
							<div className="value">${getPlan().price_usd}</div>
						</div>

						{GO('LegalPayment', '1QJfp8TgSW-yyn9BDNXssw', [
							<></>,
							<Bot>
								<label className={`legal ${legal ? '--active' : '--inactive'}`}>
									<input type="checkbox" onChange={e => handleLegal(e)} />
									<div />
									<RichText data={order.default_bottom} />
								</label>
							</Bot>,
						])}
						<PaymentBlock>
							{GO('LegalPayment', '1QJfp8TgSW-yyn9BDNXssw', [
								<></>,
								<div className="legalOverlay" onClick={handleLegalOverlay} />,
							])}
							{activeMethod === 'card' && <CD />}
							{GO('TogglePaddle', 'TogglePaddle', [
								<>{activeMethod === 'paypal' && <PP />}</>,
								<>{activeMethod === 'paypal' && <PD />}</>,
							])}
							{GO('LegalPayment', '1QJfp8TgSW-yyn9BDNXssw', [
								<>
									{activeMethod !== null && (
										<Bot style={{ textAlign: 'center' }}>
											<RichText data={order.alternative_bottom} />
										</Bot>
									)}
								</>,
								<></>,
							])}
							{activeMethod === null && (
								<Bot style={{ textAlign: 'center' }}>
									<div
										className="paymentMethodButton"
										onClick={() => handlePaymentMethodChange('card')}
									>
										<Button type={1} hue={'pink'} title={translations.payment_card}></Button>
									</div>
									<div
										className="paymentMethodButton"
										onClick={() => handlePaymentMethodChange('paypal')}
									>
										<Button type={1} hue={'pink'} title="PayPal"></Button>
									</div>
								</Bot>
							)}
						</PaymentBlock>
					</Summary>
				</div>
			</>
		);
	};

	const handlePaymentMethodChange = v => {
		setActiveMethod(v);
		log('Order', 'Store', 'ChangePaymentMethod--' + v);
		slog(`Payment Method (${getPlan().price_usd}, ${v})`, values.json.email);
		animateScrollTo(document.querySelector('#summary'));
		fblog('track', 'AddToCart', { value: Number(getPlan().price_usd), currency: 'USD' });
		splog('ADD_CART', { currency: 'USD', price: Number(getPlan().price_usd), transaction_id: cookie.load('uid') });
		eclog(getPlan(), 'add');
		log('Order', 'Store', 'InitiateCheckout');
		log('Order', 'Store', 'InitiateCheckout--method');
		eclog(getPlan(), 'checkout');
		window.__insp && window.__insp.push(['tagSession', `addToCart`]);
	};

	const handlePaypalClick = () => {
		clearTimeout(window.atcevent);
		window.atcevent = setTimeout(() => {
			axios
				.post('/.netlify/functions/email_update', {
					data: { email: values.json.email },
					params: { paid: 'false', initiate_checkout: 'paypal' },
				})
				.then(e => true);
			fblog('track', 'AddToCart', { value: Number(getPlan().price_usd), currency: 'USD' });
			splog('ADD_CART', {
				currency: 'USD',
				price: Number(getPlan().price_usd),
				transaction_id: cookie.load('uid'),
			});
			eclog(getPlan(), 'add');
			log('Order', 'Store', 'InitiateCheckout');
			log('Order', 'Store', 'InitiateCheckout--paypal');
			eclog(getPlan(), 'checkout');
			slog(`Initiate Checkout (${getPlan().price_usd}, Paypal)`, values.json.email);
			window.__insp && window.__insp.push(['tagSession', `addToCart`]);
		}, 500);
	};

	const showLoader = () => {
		if (document.querySelector('.paddle-checkout')) {
			document.querySelector('.paddle-checkout').classList.add('--loading');
		}
	};
	const hideLoader = () => {
		if (document.querySelector('.paddle-checkout')) {
			setTimeout(() => document.querySelector('.paddle-checkout').classList.remove('--loading'), 100);
		}
	};

	const PD = () => {
		return (
			<>
				<div className="paddle-checkout">
					<div className="paddle-checkout-wrapper" />
					<div className="loader" />
				</div>
				<Script
					url="https://cdn.paddle.com/paddle/paddle.js"
					onLoad={() => {
						showLoader();
						window.Paddle.Setup({
							vendor: 116667,
							eventCallback: function(data) {
								log('Paddle', data.event, 'Inline');
								if (data.event === 'Checkout.Loaded') {
									hideLoader();
								}
							},
						});
						const plan = getPlan();
						const config = {
							country: locale ? locale.countrycode : null,
							postcode: locale ? locale.zipcode : null,
							email: values ? values.email : null,
							product:
								process.env.NODE_ENV === 'production' &&
								!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
									? plan.paddle_id
									: plan.paddle_sb_id,
							success: `${window.location.origin}/create-profile?id=${id}&pad=0`,
						};
						axios
							.post('/.netlify/functions/paddle_paylink', {
								data: { ...config },
							})
							.then(data => {
								console.log(window.Paddle, window.Paddle.Checkout);
								window.Paddle.Checkout.open({
									override: data.data.response.url,
									method: 'inline',
									frameTarget: 'paddle-checkout-wrapper',
									frameInitialHeight: 366,
									frameStyle: 'width:100%; background-color: transparent; border: none;',
								});
							});
					}}
				/>
			</>
		);
	};
	const PP = () => {
		const plan = getPlan();
		if (plan.name === 'lifetime') {
			return (
				<div>
					<PayPalButton
						onClick={() => handlePaypalClick()}
						amount={getPlan().price_usd}
						currency="USD"
						shippingPreference="NO_SHIPPING"
						style={{ label: 'checkout', height: 46 }}
						options={{
							vault: true,
							clientId:
								process.env.NODE_ENV === 'production' &&
								!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
									? 'AU8gnUcaQNsxD_strs8Myx54XYYNmPQi6IkuPigztvgWJjvhpkJlmb1S_Hug91mNAsepTgqlqFERyMLD'
									: 'AV14at4GExgySgKTLjoPQ4hXoaBCeKqk2WV4udQFJbKadgJpbQXDfv6dCtxzNJne1kcxc6fiThn52olD',
							disableFunding: 'card',
						}}
						onCancel={object => {
							return new Promise(function(resolve, reject) {
								setTimeout(() => {
									window.location.replace(`/choose-plan?cancel&id=${id}`);
								}, 300);
							});
						}}
						onApprove={(data, actions) => {
							window.location.replace(
								window.location.origin +
									`${lang.length === 0 ? `` : `/${lang}`}/create-profile?id=${id}&pid=lifetime`,
							);
						}}
					/>
				</div>
			);
		} else {
			return (
				<div>
					<PayPalButton
						onClick={() => handlePaypalClick()}
						amount={getPlan().price_usd}
						currency="USD"
						shippingPreference="NO_SHIPPING"
						style={{ label: 'checkout', height: 46 }}
						options={{
							vault: true,
							clientId:
								process.env.NODE_ENV === 'production' &&
								!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
									? 'AU8gnUcaQNsxD_strs8Myx54XYYNmPQi6IkuPigztvgWJjvhpkJlmb1S_Hug91mNAsepTgqlqFERyMLD'
									: 'AV14at4GExgySgKTLjoPQ4hXoaBCeKqk2WV4udQFJbKadgJpbQXDfv6dCtxzNJne1kcxc6fiThn52olD',
							disableFunding: 'card',
						}}
						createSubscription={(data, actions) => {
							return actions.subscription.create({
								plan_id:
									process.env.NODE_ENV === 'production' &&
									!(typeof window !== 'undefined' && window.location.origin.indexOf('netlify') > -1)
										? getPlan().paypal_id
										: getPlan().paypal_sb_id,
							});
						}}
						onCancel={object => {
							return new Promise(function(resolve, reject) {
								setTimeout(() => {
									window.location.replace(`/choose-plan?cancel&id=${id}`);
								}, 300);
							});
						}}
						onApprove={(data, actions) => {
							return actions.subscription.get().then(function(details) {
								window.location.replace(
									window.location.origin +
										`${lang.length === 0 ? `` : `/${lang}`}/create-profile?id=${id}&pid=${
											data.subscriptionID
										}`,
								);
							});
						}}
					/>
				</div>
			);
		}
	};
	const CD = () => {
		renderChargedesk();
		return <div id="chargedesk-wrapper" />;
	};

	return (
		<>
			<Meta {...props} />
			<Helmet>
				<script type="application/ld+json">
					{JSON.stringify({
						'@context': 'http://schema.org',
						'@type': 'WebPage',
						url: meta.domain,
						name: meta.title,
						description: meta.description,
					})}
				</script>
			</Helmet>
			<Layout>
				<Timer2 {...props} />
				{GO('Lifetime', 'meLeuVnCQWqzpz0a8-wU-A', [
					<>
						<style>{`
							.orderItem.--test{display:none;}
							.orderItem:nth-of-type(2) {
								border-top-width: 30px;
							}
							.orderItem:nth-of-type(2):before {
								content: '${translations.popular_choice.toUpperCase()}';
								position: absolute;
								top: -30px;
								left: 0;
								right: 0;
								height: 30px;
								text-align: center;
								display: grid;
								align-items: center;
								font-size: 0.7rem;
								font-weight: 600;
								color: ${colors.teal.base};
								border-bottom: 1px solid ${colors.background[1]};
							}
						`}</style>
					</>,
					<>
						<style>{`
							.orderItem.--test{display:block;}
							.orderItem:nth-of-type(3){display:none;}
							.orderItem:nth-of-type(1) {
								border-top-width: 30px;
							}
							.orderItem:nth-of-type(1):before {
								content: '${translations.limited_offer.toUpperCase()}';
								position: absolute;
								top: -30px;
								left: 0;
								right: 0;
								height: 30px;
								text-align: center;
								display: grid;
								align-items: center;
								font-size: 0.7rem;
								font-weight: 600;
								color: ${colors.teal.base};
								border-bottom: 1px solid ${colors.background[1]};
							}
						`}</style>
					</>,
				])}

				<Benefits2
					onClick={() => {
						log('Payment', 'Engagement', 'click_benefits');
					}}
				>
					<Block>
						<h2>{translations.lose_enjoy}</h2>
						<div>
							{config.benefits.map((item, index) => (
								<div key={index}>
									<img src={item.image.url} />
									<p>{item.title}</p>
								</div>
							))}
						</div>
					</Block>
				</Benefits2>

				<PageWrapper>
					<h1>{translations.choose_plan}</h1>
					<Order2>
						<Plans2>
							{order.plans.map((item, index) => (
								<label
									className={`${item.value ? '--active' : '--inactive'} orderItem ${
										item.test ? '--test' : ''
									}`}
									key={index}
								>
									<input
										type="radio"
										name="plan"
										value={item.name}
										defaultChecked={item.value}
										onChange={e => handleOptionChange(e)}
									></input>
									<div>
										<div className="status" />
										<div>
											<h2>{item.title}</h2>
											<h3>
												{item.price_number}
												<span>{item.price_subtitle}</span>
											</h3>
											<small>
												{item.subtitle.split(' ').map((item, index) => (
													<span key={index}>{item} </span>
												))}
											</small>
											<div className="discount">{item.discount}</div>
										</div>
									</div>
								</label>
							))}
							{GO('LegalPayment', '1QJfp8TgSW-yyn9BDNXssw', [<></>, <small>{order.prices_usd}</small>])}
						</Plans2>
						{renderSummary()}
					</Order2>
				</PageWrapper>
				<VisibilitySensor
					partialVisibility={true}
					onChange={v => v && log('Payment', 'Engagement', 'view_reviews')}
				>
					<Reviews
						onClick={() => {
							log('Payment', 'Engagement', 'click_reviews');
						}}
					>
						<Block>
							<h2>{config.reviews_title}</h2>
							<SocialProof reviews={config.reviews} />
							<a className="cta" href={'#'} target="_blank" onClick={e => handleCallToAction(e)}>
								<Button type={1} hue={'pink'} title={translations.submit_payment} />
							</a>
						</Block>
					</Reviews>
				</VisibilitySensor>
			</Layout>
		</>
	);
};
